import type { BloodTestPackage as BloodTestPackageType } from "../../models";
import { CatalogItem } from "../catalog-item";

// Above this many products the catalog switches to compact (simplified) cards (matches VD).
export const COMPACT_CARDS_THRESHOLD = 7;

type CatalogListProps = {
  bloodTestPackages: BloodTestPackageType[];
  onSelect: (bloodTestPackage: BloodTestPackageType, index: number) => void;
  isProductInCart?: (bloodTestPackage: BloodTestPackageType) => boolean;
  buttonLabel?: string;
  simplified?: boolean;
};

export const CatalogList = ({
  bloodTestPackages,
  onSelect,
  isProductInCart,
  buttonLabel,
  simplified,
}: CatalogListProps) => (
  <div className="grid w-full grid-cols-1 gap-2 self-start lg:gap-3">
    {bloodTestPackages.map((bloodTestPackage, index) => (
      <CatalogItem
        key={bloodTestPackage.uuid}
        bloodTestPackage={bloodTestPackage}
        onSelect={(pkg) => onSelect(pkg, index + 1)}
        isSelected={isProductInCart?.(bloodTestPackage) ?? false}
        buttonLabel={buttonLabel}
        simplified={simplified}
      />
    ))}
  </div>
);
